import { forwardRef, useCallback, useMemo, useState } from 'react'
import { ButtonGroup, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import {
  CircleFill,
  Coin,
  Diagram3Fill,
  PrinterFill,
  Upload,
} from 'react-bootstrap-icons'
import { CheckCircleFill, XCircleFill } from "react-bootstrap-icons";

import Dropdown from 'react-bootstrap/Dropdown'
import Table from 'react-bootstrap/Table'
import { BsPencil, BsShare, BsTrash } from 'react-icons/bs'
import { FaClone, FaCube, FaCubes, FaDashcube } from 'react-icons/fa'
import { MdPriceCheck } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom'
import { useProducts } from '../../hooks/useProducts'
import { CustomButton } from '../CustomButton'
import { ModalEnviarOfertasLeroy } from './ModalEnviarOfertasLeroy'

import './listaproduto.css'

import { Eye, EyeSlash } from '@phosphor-icons/react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { toast } from 'react-toastify'
import { useOrdenation } from '../../hooks/useOrdenation'
import apinode from '../../services/apinode'
import { formatPrice } from '../../utils/formatPrice'
import { getValue } from '../../utils/getValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Ask } from '../Ask'
import { CustomSpinner } from '../CustomSpinner'
import { ModalConsultarHeranca } from './ModalConsultarHeranca'
import { ModalEditarPrecos } from './ModalEditarPrecos'

const ListaProdutos = forwardRef((props, ref) => {
  const [tipoFiltro, setTipoFiltro] = useState('UN')
  const [isModalEnviarOfertasOpen, setIsModalEnviarOfertasOpen] =
    useState(false)
  const [isModalEditarPrecosOpen, setIsModalEditarPrecosOpen] = useState(false)
  const [loading, setIsLoading] = useState(false)
  const [isPrintRequestLoading, setIsPrintRequestLoading] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState({})
  const [isStockMatrizLoading, setIsStockMatrizLoading] = useState({})
  const [stockMatriz, setStockMatriz] = useState(null)
  const [isStockInfoOpen, setIsStockInfoOpen] = useState({})
  const [hierarchy, setHierarchy] = useState({})
  const [isConsultarHerancaLoading, setIsConsultarHerancaLoading] = useState({})
  const [isModalConsultarHerancaOpen, setIsModalConsultarHerancaOpen] =
    useState(false)
  const [statusLocal, setStatusLocal] = useState({});

  const getStatus = (produto) => {
    const sku = produto?.SKU;
    return statusLocal[sku] ?? (produto.HABILITADO_VENDA ?? 'S');
  };



  const alterarStatusProduto = async (sku) => {
    try {
      const response = await apinode.put(
        `/estoque/alteracao/${localStorage.idconta}`,
        { sku }
      );

      console.log("Resposta da API:", response.data);

      // ✅ feedback opcional
      toast.success(response.data.message);

    } catch (error) {
      console.error("Erro ao alterar produto:", error);
      toast.error("Erro ao alterar produto.");
    }
  };


  pdfMake.addVirtualFileSystem(pdfFonts)

  const generatePDF = async (data) => {
    setIsLoading(true)
    const isAdmin = localStorage.admin === 'SIM'
    const currentDateTime = new Date().toLocaleString('pt-BR')
    const currentUser = localStorage.username

    const docDefinition = {
      footer: function (currentPage, pageCount) {
        return {
          text: `Página ${currentPage.toString()} de ${pageCount.toString()}`,
          alignment: 'center',
        }
      },
      content: [
        { text: 'Lista de Produtos', style: 'header' },
        {
          text: `Data e Hora da Impressão: ${currentDateTime}`,
          fontSize: 8,
          margin: [0, 0, 0, 5],
        },
        { text: `Usuário: ${currentUser}`, fontSize: 8, margin: [0, 0, 0, 5] },
        {
          table: {
            headerRows: 1,
            widths: [50, 150, 70, 70, 60, 60, 60, 60, 60],
            body: [
              [
                'SKU',
                'Descrição',
                'Preço Venda',
                ...(isAdmin ? ['Custo'] : []),
                'Reservado',
                'Saldo',
              ],
              ...data.map((produto) => [
                { text: produto.SKU, fontSize: 8 },
                { text: produto.DESCRICAO, fontSize: 8 },
                {
                  text: `R$ ${parseFloat(produto.PRECOVENDA).toFixed(2).replace('.', ',')}`,
                  fontSize: 8,
                },
                ...(isAdmin
                  ? [
                    {
                      text: `R$ ${parseFloat(produto.PRECOCUSTO || 0)
                        .toFixed(2)
                        .replace('.', ',')}`,
                      fontSize: 8,
                    },
                  ]
                  : []),
                { text: produto.QTRESERV, fontSize: 8 },
                { text: produto.QTEST, fontSize: 8 },
              ]),
            ],
            style: 'tableStyle',
            layout: {
              defaultBorder: false,
            },
          },
        },
      ],
      styles: {
        header: {
          fontSize: 10,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        tableStyle: {
          border: 'none',
          fontSize: 8,
        },
      },
      página,
    }

    try {
      const pdf = pdfMake.createPdf(docDefinition)
      pdf.open()
    } finally {
      setIsLoading(false)
    }
  }

  const navigate = useNavigate()

  const { productsToExport, setProductsToExport } = useProducts()

  const filteredProdutos = useMemo(() => {
    let data = props.arrayClientes

    if (tipoFiltro) {
      data = data.filter((cliente) => cliente.UNIDADE === tipoFiltro)
    }

    return data
  }, [props.arrayClientes, tipoFiltro])

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(filteredProdutos, 'SKU')

  // Opções para o dropdown de quantidade de itens por página
  const itemsPerPageOptions = [10, 25, 50]

  // Opções para o dropdown de filtro por tipo
  const tipoFiltroOptions = ['', 'UN', 'KIT', 'PC']

  const totalCusto = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      acc = acc + item.PRECOCUSTO

      return acc
    }, 0)

    return formatPrice(data)
  }, [filteredProdutos])

  const totalVenda = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      acc = acc + item.PRECOVENDA

      return acc
    }, 0)

    return formatPrice(data)
  }, [filteredProdutos])

  const totalEstoque = useMemo(() => {
    const data = filteredProdutos.reduce((acc, item) => {
      if (item.QTESTGER > 0) {
        acc = acc + item.QTESTGER * item.PRECOCUSTO
      }

      return acc
    }, 0)

    return formatPrice(data)
  }, [filteredProdutos])

  async function consultarHeranca(sku, index) {
    setHierarchy({})

    try {
      setIsConsultarHerancaLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode.get(
        `/consultar_heranca/${localStorage.idconta}?search=${sku}`,
      )

      if (response.data?.children.length === 0 && !response.data?.dad) {
        return toast.warn('Este produto não está associado à nenhum outro')
      }

      setHierarchy(response.data)

      setIsModalConsultarHerancaOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao consultar herança')
    } finally {
      setIsConsultarHerancaLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function handlePrintLabel(product) {
    try {
      setIsPrintRequestLoading(true)

      await apinode.post(`/produtos/print-label/${localStorage.idconta}`, {
        sku: product.SKU,
        descricao: product.DESCRICAO,
      })

      toast.success(
        'Este produto foi enviado á uma fila. Logo ele será impresso!',
      )
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível imprimir o SKU!')
    } finally {
      setIsPrintRequestLoading(false)
    }
  }

  function handleOpenModalEditarPrecos(product) {
    setSelectedProduct(product)
    setIsModalEditarPrecosOpen(true)
  }

  const handleSelectProduct = useCallback(
    (e, product) => {
      if (e.target.checked) {
        setProductsToExport((prevState) => [...prevState, product])
      } else {
        setProductsToExport((prevState) =>
          prevState.filter((prod) => prod !== product),
        )
      }
    },
    [setProductsToExport],
  )

  async function handleGetStockMatriz(sku, index) {
    try {
      setIsStockMatrizLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const response = await apinode(
        `/estoque/produto/${process.env.REACT_APP_DATABASE_MATRIZ}/${sku}`,
      )

      if (!response.data.exists) {
        return toast.warn('Produto não foi encontrado na matriz')
      }

      setStockMatriz(response.data.stock || 0)
      setIsStockInfoOpen({
        [index]: true,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o estoque na matriz')
    } finally {
      setIsStockMatrizLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  return (
    <>
      {props.isLoadingProduct ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CustomSpinner />
        </div>
      ) : (
        <div ref={ref}>
          <div className="d-flex justify-content-between mb-2">
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="itemsPerPageDropdown"
              >
                Itens por Página ({itemsPerPage})
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {itemsPerPageOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    onClick={() => setItemsPerPage(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <p>
              <strong>
                Mostrando {filteredItems.length} de{' '}
                {new Intl.NumberFormat('pt-BR').format(filteredProdutos.length)}{' '}
                resultados
              </strong>
            </p>

            {/* Dropdown para filtrar por tipo */}
            <Dropdown className="mr-2">
              <Dropdown.Toggle
                variant="secondary"
                id="tipoFiltroDropdown"
              >
                Filtrar por Tipo ({tipoFiltro || 'Todos'})
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {tipoFiltroOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    onClick={() => setTipoFiltro(option)}
                  >
                    {option || 'Todos'}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {localStorage.admin === 'SIM' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '20px',
              }}
            >
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  fontSize: 16,
                  fontWeight: 'bold',
                }}
              >
                <CircleFill color="#f39c12" />
                Total Custo: {totalCusto}
              </p>

              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                <CircleFill color="#229954" />
                Total Venda: {totalVenda}
              </p>

              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '5px',
                  fontSize: 16,
                  fontWeight: 'bold',
                }}
              >
                <CircleFill color="#3498db" />
                Total Estoque: {totalEstoque}
              </p>
            </div>
          )}

          <Table
            hover
            responsive
            className="nowrap"
            id="table-to-xls"
          >
            <thead>
              <tr className="table-primary">
                <th
                  style={{
                    fontSize: '12px',
                  }}
                ></th>

                <th
                  style={{
                    fontSize: '12px',
                  }}
                >
                  Imagem
                </th>

                <Th
                  label="SKU"
                  value="SKU"
                  style={{ fontSize: '12px' }}
                />

                <Th
                  label="Descrição"
                  value="DESCRICAO"
                  style={{ fontSize: '12px' }}
                />

                <th style={{ fontSize: '12px' }}>EAN</th>

                <th style={{ fontSize: '12px' }}>NCM</th>

                <Th
                  label="Preço Custo"
                  value="PRECOCUSTO"
                  style={{ fontSize: '12px' }}
                />

                <Th
                  label="Preço Venda"
                  value="PRECOVENDA"
                  style={{ fontSize: '12px' }}
                />

                <Th
                  label="Estoque"
                  value="QTESTGER"
                  style={{ fontSize: '12px' }}
                />

                <th style={{ fontSize: '12px' }}>Pend.Dev</th>
                <th style={{ fontSize: '12px' }}>Avarias</th>
                <th style={{ fontSize: '12px' }}>Reservado</th>
                <th style={{ fontSize: '12px' }}>Saldo</th>
                <th style={{ fontSize: '12px' }}>Matriz</th>
                <th style={{ fontSize: '12px' }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.length > 0 ? (
                filteredItems.map((produto, index) => (
                  <>
                    <tr key={produto.CODPRODUTO}>
                      <td>
                        <OverlayTrigger
                          overlay={<Tooltip>Consultar Herança</Tooltip>}
                        >
                          <CustomButton
                            color="#2D936C"
                            onClick={() => consultarHeranca(produto.SKU, index)}
                            isLoading={isConsultarHerancaLoading[index]}
                          >
                            <Diagram3Fill />
                          </CustomButton>
                        </OverlayTrigger>
                      </td>

                      <td>
                        {produto.IMG_CAPA === null ? (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_API}/imagens/no-image.jpg`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_BACKEND_API}/imagens/no-image.jpg`}
                              style={{
                                width: '60px',
                                height: '45px',
                                minWidth: '60px',
                                minHeight: '45px',
                                cursor: 'pointer',
                              }}
                              alt="No Image Available"
                            />
                          </a>
                        ) : (
                          <a
                            href={`${process.env.REACT_APP_BACKEND_API}/imagens/${produto.IMG_CAPA}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_BACKEND_API}/imagens/${produto.IMG_CAPA}`}
                              style={{
                                width: '60px',
                                height: '45px',
                                minWidth: '60px',
                                minHeight: '45px',
                                cursor: 'pointer', // Mostra o cursor de clique
                              }}
                              alt="Imagem do Produto"
                            />
                          </a>
                        )}
                      </td>
                      <td style={{ fontSize: '12px' }}>
                        <Form.Check
                          checked={productsToExport.includes(produto)}
                          type="checkbox"
                          onChange={(e) => handleSelectProduct(e, produto)}
                          inline
                        />

                        {produto.SKU}
                      </td>
                      <td style={{ fontSize: '12px' }}>
                        <div>
                          {getStatus(produto) === 'N' ? (
                            <span className="badge bg-danger" style={{ fontSize: '11px' }}>
                              {produto.DESCRICAO}
                            </span>
                          ) : (
                            produto.DESCRICAO
                          )}
                        </div>

                        <div>
                          {produto.FORMATO === 'S' ? (
                            <span className="badge bg-primary">
                              Formato Simples
                            </span>
                          ) : produto.FORMATO === 'C' ? (
                            <span className="badge bg-success">
                              Formato Composição
                            </span>
                          ) : null}
                        </div>
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {produto?.GTIN ? produto?.GTIN : 'Sem EAN'}
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {getValue(produto?.CODNCM)}
                      </td>

                      {localStorage.admin === 'SIM' ? (
                        <td style={{ fontSize: '12px' }}>
                          {produto.PRECOCUSTO
                            ? produto.PRECOCUSTO.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).replace('R$', '')
                            : '0,00'}
                        </td>
                      ) : (
                        <td style={{ fontSize: '12px' }}>
                          {/* <FaBan title='Sem permissão'/> */}
                        </td>
                      )}

                      <td style={{ fontSize: '12px' }}>
                        {produto.PRECOVENDA
                          ? produto.PRECOVENDA.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).replace('R$', '')
                          : '0,00'}
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {produto.QTESTGER
                          ? produto.QTESTGER.toFixed(2).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                          : '0'}
                      </td>
                      <td style={{ fontSize: '12px' }}>
                        {produto.QTPENDDEV
                          ? produto.QTPENDDEV.toFixed(2).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                          : '0'}
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {produto.QTINDENIZ
                          ? produto.QTINDENIZ.toFixed(2).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                          : '0'}
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {produto.QTRESERV
                          ? produto.QTRESERV.toFixed(2).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                          : '0'}
                      </td>

                      <td style={{ fontSize: '12px' }}>
                        {produto.QTEST
                          ? produto.QTEST.toFixed(2).replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ',',
                          )
                          : '0'}
                      </td>

                      <td
                        className="col-est-matriz"
                        style={{ fontSize: '12px' }}
                      >
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {isStockInfoOpen[index]
                                ? 'Ocultar Estoque'
                                : 'Buscar Estoque'}
                            </Tooltip>
                          }
                        >
                          <CustomButton
                            isLoading={isStockMatrizLoading[index]}
                            isDisabled={!produto.SKU}
                            onClick={() =>
                              isStockInfoOpen[index]
                                ? setIsStockInfoOpen({
                                  [index]: false,
                                })
                                : handleGetStockMatriz(produto.SKU, index)
                            }
                          >
                            {isStockInfoOpen[index] ? (
                              <EyeSlash weight="fill" />
                            ) : (
                              <Eye weight="fill" />
                            )}
                          </CustomButton>
                        </OverlayTrigger>

                        {isStockInfoOpen[index] && stockMatriz && (
                          <div
                            style={{
                              width: '100%',
                              marginTop: 10,
                            }}
                          >
                            <p
                              style={{
                                all: 'unset',
                                fontSize: 12,
                              }}
                            >
                              Estoque: {Number(stockMatriz).toFixed(2)}
                            </p>
                          </div>
                        )}
                      </td>

                      <td>
                        <ButtonGroup>

                          <OverlayTrigger
                            overlay={<Tooltip>Habilitar/Desabilitar</Tooltip>}
                          >
                            <CustomButton
                              onClick={async () => {
                                const sku = produto.SKU;

                                // 🔄 1) Toggle otimista (muda o ícone antes da API)
                                setStatusLocal(prev => {
                                  const atual = prev[sku] ?? (produto.HABILITADO_VENDA ?? 'S');
                                  const novo = atual === 'S' ? 'N' : 'S';
                                  return { ...prev, [sku]: novo };
                                });

                                try {
                                  // 🔥 2) Chama API (toggle real no banco)
                                  const data = await alterarStatusProduto(sku);

                                  // ✅ pega status final confirmado (S | N)
                                  const confirmado = data?.produto?.para;
                                  if (confirmado === 'S' || confirmado === 'N') {
                                    setStatusLocal(prev => ({ ...prev, [sku]: confirmado }));
                                  }
                                } catch (error) {
                                  // ⛔ 3) Se deu erro, reverte para o valor anterior
                                  setStatusLocal(prev => {
                                    const atual = prev[sku] ?? (produto.HABILITADO_VENDA ?? 'S');
                                    const revertido = atual === 'S' ? 'N' : 'S';
                                    return { ...prev, [sku]: revertido };
                                  });
                                }

                                setSelectedProduct(produto);
                              }}
                            >
                              {getStatus(produto) === 'S'
                                ? <CheckCircleFill size={18} color="white" />
                                : <XCircleFill size={18} color="white" />
                              }
                            </CustomButton>
                          </OverlayTrigger>




                          <OverlayTrigger
                            overlay={
                              <Tooltip>Enviar Oferta Leroy Merlin</Tooltip>
                            }
                          >
                            <CustomButton
                              color="#1e8449"
                              onClick={() => {
                                setSelectedProduct(produto)
                                setIsModalEnviarOfertasOpen(true)
                              }}
                            >
                              <Upload />
                            </CustomButton>
                          </OverlayTrigger>

                          {localStorage.admin === 'SIM' && (
                            <OverlayTrigger
                              overlay={
                                <Tooltip>
                                  Enviar para Cálculo Real dos Lucros
                                </Tooltip>
                              }
                            >
                              <CustomButton
                                color="#F54927"
                                onClick={() => {
                                  Ask(
                                    'Deseja ir para Cálculo Real Dos Lucros?',
                                    () =>
                                      navigate('/mercadolivre/calculo-lucros', {
                                        state: {
                                          codproduto: produto.CODPRODUTO,
                                          sku: produto.SKU,
                                          descricao: produto.DESCRICAO,
                                          precocusto: produto.PRECOCUSTO,
                                          precovenda: produto.PRECOVENDA,
                                        },
                                      }),
                                  )
                                }}
                              >
                                <Coin />
                              </CustomButton>
                            </OverlayTrigger>
                          )}

                          <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <button className="btn btn-warning btn-sm">
                              <Link
                                to={`/produtos/${produto.CODPRODUTO}`}
                                target="_blank"
                              >
                                <BsPencil />
                              </Link>
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Imprimir Etiqueta</Tooltip>}
                          >
                            <CustomButton
                              color=" #510e6c "
                              onClick={() => {
                                handlePrintLabel(produto)
                              }}
                              isLoading={isPrintRequestLoading}
                            >
                              <PrinterFill />
                            </CustomButton>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Editar Preços</Tooltip>}
                          >
                            <button
                              className="btn btn-sm"
                              style={{
                                backgroundColor: '#005d27',
                              }}
                              onClick={() =>
                                handleOpenModalEditarPrecos(produto)
                              }
                            >
                              <MdPriceCheck
                                color="white"
                                size={15}
                              />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip>Deletar</Tooltip>}>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                props.clickDelete(produto.CODPRODUTO)
                              }
                              disabled={localStorage.admin !== 'SIM'}
                            >
                              <BsTrash />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={<Tooltip>Exportar</Tooltip>}>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                props.clickExport(
                                  produto.SKU,
                                  produto.PRECOVENDA,
                                  produto.DESCRICAO,
                                )
                              }
                            >
                              <BsShare />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Manutenção de Estoque</Tooltip>}
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => props.clickAjustStock(produto.SKU)}
                            >
                              <FaCubes />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={
                              <Tooltip>Movimentações do produto</Tooltip>
                            }
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                props.clickMovProd(
                                  produto.SKU,
                                  produto.DESCRICAO,
                                )
                              }
                            >
                              <FaCube />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Clonar Cadastro</Tooltip>}
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => props.clickClonar(produto.SKU)}
                            >
                              <FaClone />
                            </button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Ver Composição</Tooltip>}
                          >
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => props.clickComposicao(produto.SKU)}
                            >
                              <FaDashcube />
                            </button>
                          </OverlayTrigger>
                        </ButtonGroup>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="12"
                    className="py-3"
                  >
                    <div>Nenhum resultado encontrado para a pesquisa.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <Paginate />

          <button
            onClick={() => {
              setIsLoading(true)
              generatePDF(props.arrayClientes)
            }}
            className="btn btn-primary btn-sm"
            disabled={loading} // Desabilita o botão enquanto isLoading for true
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              'Gerar PDF'
            )}
          </button>
        </div>
      )}

      {isModalEnviarOfertasOpen && (
        <ModalEnviarOfertasLeroy
          product={selectedProduct}
          isOpen={isModalEnviarOfertasOpen}
          onClose={() => setIsModalEnviarOfertasOpen(false)}
        />
      )}

      {isModalEditarPrecosOpen && (
        <ModalEditarPrecos
          productData={selectedProduct}
          isOpen={isModalEditarPrecosOpen}
          onClose={() => setIsModalEditarPrecosOpen(false)}
        />
      )}

      {isModalConsultarHerancaOpen && (
        <ModalConsultarHeranca
          isOpen={isModalConsultarHerancaOpen}
          onClose={() => setIsModalConsultarHerancaOpen(false)}
          dad={hierarchy.dad}
          kids={hierarchy.children}
        />
      )}
    </>
  )
})

export default ListaProdutos
